import { Typography } from "@mui/material";
import React from "react";
import { legend__text } from "../style";

export default function PartialDentureAcrylic() {
  return <Typography sx={legend__text}>PRD-ACR</Typography>;
}
